const httpGetAsync = `// url Async requesting function
function httpGetAsync(theUrl, callback)
{
    // create the request object
    var xmlHttp = new XMLHttpRequest();

    // set the state change callback to capture when the response comes in
    xmlHttp.onreadystatechange = function()
    {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
        {
            callback(xmlHttp.responseText);
        }
    }

    // open as a GET call, pass in the url and set async = True
    xmlHttp.open("GET", theUrl, true);

    // call send with no params as they were passed in on the url string
    xmlHttp.send(null);

    return;
}`;

export const javascriptEndpoints = {
    anonymousid:
`<!DOCTYPE html>
<html>
<script>

// callback for anonymous id -- for first time users
function tenorCallback_anonid(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    anon_id = response_objects["anon_id"];

    user_anon_id = anon_id;
    alert(user_anon_id);
}

// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>

<body>


</body>
</html>`,

    trendinggifs:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for trending top 10 GIFs
function tenorCallback_trending(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_gifs = response_objects["results"];

    // load the GIFs -- for our example we will load the first GIFs preview size (nanogif) and share size (tinygif)

    document.getElementById("preview_gif").src = top_10_gifs[0]["media"][0]["nanogif"]["url"];

    document.getElementById("share_gif").src = top_10_gifs[0]["media"][0]["tinygif"]["url"];

    return;

}

// function to call the trending and category endpoints
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 10;

    // get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
    var trending_url = "https://g.tenor.com/v1/trending?key=" + apikey + "&limit=" + lmt;
    httpGetAsync(trending_url,tenorCallback_trending);


    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>
<style>
.container {
    position: relative;
    text-align: center;
    color: white;
}
.title {
text-align: center;
}
.centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<body>

<h2 class="title">GIF loaded - preview image</h2>
<div class="container">
<img id="preview_gif" src="" alt="" style="">
</div>

<h2 class="title">GIF loaded - share image</h2>
<div class="container">
<img id="share_gif" src="" alt="" style="">
</div>

</body>
</html>`,

    categories:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for GIF categories
function tenorCallback_categories(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    categories = response_objects["tags"];

    // load the categories - example is for the first category

    // url to load:
    var imgurl = categories[0]["image"];

    // text to overlay on image:
    var txt_overlay = categories[0]["name"];


    // search to run if user clicks the category
    var category_search_path = categories[0]["path"];

    document.getElementById("category_gif").src = imgurl
    document.getElementById("catgif_caption").innerHTML = txt_overlay
    document.getElementById("cat_link").href = category_search_path

    return;
}

// function to call the trending and category endpoints
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 10;

    // get the current list of categories - using the default locale of en_US
    var cat_url = "https://g.tenor.com/v1/categories?key=" + apikey;

    httpGetAsync(cat_url,tenorCallback_categories);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>
<style>
.container {
    position: relative;
    text-align: center;
    color: white;
}
.title {
text-align: center;
}
.centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<body>

<h2 class="title">GIF Category</h2>
<div class="container">
    <a id="cat_link" href="">
        <img id="category_gif" src="" alt="" style="">
        <div id="catgif_caption" class="centered"></div>
    </a>
</div>

</body>
</html>`,

    search:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for the top 8 GIFs of search
function tenorCallback_search(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_gifs = response_objects["results"];

    // load the GIFs -- for our example we will load the first GIFs preview size (nanogif) and share size (tinygif)

    document.getElementById("preview_gif").src = top_10_gifs[0]["media"][0]["nanogif"]["url"];

    document.getElementById("share_gif").src = top_10_gifs[0]["media"][0]["tinygif"]["url"];

    return;

}


// function to call the search endpoint
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 8;

    // test search term
    var search_term = "excited";

    // using default locale of en_US
    var search_url = "https://g.tenor.com/v1/search?q=" + search_term + "&key=" +
            apikey + "&limit=" + lmt;

    httpGetAsync(search_url,tenorCallback_search);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>

<body>

<h2># 1 GIF loaded - preview image</h2>
<img id="preview_gif" src="" alt="" style="width:220px;height:164px;">

<h2># 1 GIF loaded - share image</h2>
<img id="share_gif" src="" alt="" style="width:498px;height:372px;">

</body>
</html>`,

    registershare:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for share event
function tenorCallback_share(responsetext)
{
    // no action is needed in the share callback
}



// function to call the register share endpoint
function send_share(search_term,shared_gifs_id)
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 8;

    // using default locale of EN_US
    var share_url = "https://g.tenor.com/v1/registershare?id=" + shared_gifs_id + "&key=" + apikey
        + "&q=" + search_term;

    httpGetAsync(share_url,tenorCallback_share);
}

// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// grab search term from cookies or some other storage
search_term = "excited";

// GIF id from the shared gif
// shared_gifs_id = gif_json_response_object_from_search[0][“id”]
shared_gifs_id = 5957952; // example

// send the share notifcation back to Tenor
send_share(search_term,shared_gifs_id);

alert("share sent!");


</script>

<body>

</body>
</html>`,

    autocomplete:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for share event
function tenorCallback_autocomplete(responsetext)
{
    var response_objects = JSON.parse(responsetext);

    predicted_words = response_objects["results"];

    document.getElementById("ac_1").innerHTML = predicted_words[0];
    document.getElementById("ac_2").innerHTML = predicted_words[1];
}

// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

//partial search term
psearch_term = "exc";

// set the apikey and limit
var apikey = "LIVDSRZULELA";
var lmt = 5;

// using default locale of en_US
var autoc_url = "https://g.tenor.com/v1/autocomplete?key=" + apikey + "&q=" + psearch_term
    + "&limit=" + lmt;

// send autocomplete request
httpGetAsync(autoc_url,tenorCallback_autocomplete);


</script>

<body>

<h2>Partial Search "exc":</h2>
<h3 id = "ac_1"></h3>
<h3 id = "ac_2"></h3>

</body>
</html>`,

    suggestions:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for search suggestion event
function tenorCallback_searchSuggestion(responsetext)
{
    var response_objects = JSON.parse(responsetext);

    predicted_words = response_objects["results"];

    document.getElementById("ac_1").innerHTML = predicted_words[0];
    document.getElementById("ac_2").innerHTML = predicted_words[1];
    document.getElementById("ac_3").innerHTML = predicted_words[2];
    document.getElementById("ac_4").innerHTML = predicted_words[3];
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

//search term
psearch_term = "excited";

// set the apikey and limit
var apikey = "LIVDSRZULELA";
var lmt = 5;

// using default locale of en_US
var autoc_url = "https://g.tenor.com/v1/search_suggestions?key=" + apikey + "&q=" + psearch_term
    + "&limit=" + lmt;

// send search suggestion request
httpGetAsync(autoc_url,tenorCallback_searchSuggestion);


</script>

<body>

<h2>Search Suggestion for "excited":</h2>
<h3 id = "ac_1"></h3>
<h3 id = "ac_2"></h3>
<h3 id = "ac_3"></h3>
<h3 id = "ac_4"></h3>

</body>
</html>`,

    gifs:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for the requested gif
function tenorCallback_gifs(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    var gif = response_objects["results"];

    // load the GIFs -- for our example we will load the first GIFs preview size (nanogif) and share size (tinygif)

    document.getElementById("preview_gif").src = gif[0]["media"][0]["nanogif"]["url"];

    document.getElementById("share_gif").src = gif[0]["media"][0]["tinygif"]["url"];

    return;

}


// function to call the trending and category endpoints
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";

    // GIF id
    var gif_id = 8776030;

    // using default locale of en_US
    var search_url = "https://g.tenor.com/v1/gifs?ids=" + gif_id + "&key=" +
            apikey;

    httpGetAsync(search_url,tenorCallback_gifs);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>

<body>

<h2># 1 GIF loaded - preview image</h2>
<img id="preview_gif" src="" alt="" style="width:220px;height:164px;">

<h2># 1 GIF loaded - share image</h2>
<img id="share_gif" src="" alt="" style="width:498px;height:372px;">

</body>
</html>`,

    random:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for the random search
function tenorCallback_randomsearch(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_gifs = response_objects["results"];

    // load the GIFs -- for our example we will load the first GIFs preview size (nanogif) and share size (tinygif)

    document.getElementById("preview_gif").src = top_10_gifs[0]["media"][0]["nanogif"]["url"];

    document.getElementById("share_gif").src = top_10_gifs[0]["media"][0]["tinygif"]["url"];

    return;

}


// function to request random gifs for a given search term
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 8;

    // test search term
    var search_term = "excited";

    // using default locale of en_US
    var search_url = "https://g.tenor.com/v1/random?q=" + search_term + "&key=" +
            apikey + "&limit=" + lmt;

    httpGetAsync(search_url,tenorCallback_randomsearch);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>

<body>

<h2># 1 GIF loaded - preview image</h2>
<img id="preview_gif" src="" alt="" style="width:220px;height:164px;">

<h2># 1 GIF loaded - share image</h2>
<img id="share_gif" src="" alt="" style="width:498px;height:372px;">

</body>
</html>`,

    trendingterms:
`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for GIF categories
function tenorCallback_terms(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    terms = response_objects["results"];

    document.getElementById("res").innerHTML = terms

    return;
}

// function to call the trending terms
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 10;

    // get the current list of trending terms - using the default locale of en_US
    var cat_url = "https://g.tenor.com/v1/trending_terms?key=" + apikey;

    httpGetAsync(cat_url,tenorCallback_terms);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>
<style>
.container {
    position: relative;
    text-align: center;
    color: white;
}
.title {
text-align: center;
}
.centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<body>

<h2 class="title">Trending Terms</h2>
<div class="container" id="res">
</div>

</body>
</html>`,

    search_stickers:
`<!DOCTYPE html>
<html>
<script>

// url Async requesting function
function httpGetAsync(theUrl, callback)
{
    // create the request object
    var xmlHttp = new XMLHttpRequest();

    // set the state change callback to capture when the response comes in
    xmlHttp.onreadystatechange = function()
    {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
        {
            callback(xmlHttp.responseText);
        }
    }

    // open as a GET call, pass in the url and set async = True
    xmlHttp.open("GET", theUrl, true);

    // call send with no params as they were passed in on the url string
    xmlHttp.send(null);

    return;
}

// callback for the top 10 stickers of search
function tenorCallback_search(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_stickers = response_objects["results"];

    // load the GIFs -- for our example we will load the first sticker preview size (tinywebp) and share size (webp)

    document.getElementById("preview_sticker").src = top_10_stickers[0]["media"][0]["tinywebp_transparent"]["url"];

    document.getElementById("share_sticker").src = top_10_stickers[0]["media"][0]["webp_transparent"]["url"];

    return;

}


// function to call the search endpoint
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 10;

    // test search term
    var search_term = "excited";

    // using default locale of en_US
    var search_url = "https://g.tenor.com/v1/search?searchfilter=sticker&q=" + search_term + "&key=" +
            apikey + "&limit=" + lmt;

    httpGetAsync(search_url,tenorCallback_search);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>

<body>

<h2># 1 Sticker loaded - preview image</h2>
<img id="preview_sticker" src="" alt="" style="width:220px;height:164px;">

<h2># 1 Sticker loaded - share image</h2>
<img id="share_sticker" src="" alt="" style="width:498px;height:372px;">

</body>
</html>`,

    trending_stickers:
`<!DOCTYPE html>
<html>
<script>

// url Async requesting function
function httpGetAsync(theUrl, callback)
{
    // create the request object
    var xmlHttp = new XMLHttpRequest();

    // set the state change callback to capture when the response comes in
    xmlHttp.onreadystatechange = function()
    {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
        {
            callback(xmlHttp.responseText);
        }
    }

    // open as a GET call, pass in the url and set async = True
    xmlHttp.open("GET", theUrl, true);

    // call send with no params as they were passed in on the url string
    xmlHttp.send(null);

    return;
}

// callback for trending top 10 stickers
function tenorCallback_trending(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_stickers = response_objects["results"];

    // load the stickers -- for our example we will load the first sticker preview size (nanogif_transparent) and share size (tinygif_transparent)

    document.getElementById("preview_sticker").src = top_10_stickers[0]["media"][0]["nanogif_transparent"]["url"];

    document.getElementById("share_sticker").src = top_10_stickers[0]["media"][0]["tinygif_transparent"]["url"];

    return;

}

// function to call the trending and category endpoints
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 10;

    // get the top 10 trending stickers (updated throughout the day) - using the default locale of en_US
    var trending_url = "https://g.tenor.com/v1/trending?searchfilter=sticker&key=" + apikey + "&limit=" + lmt;
    httpGetAsync(trending_url,tenorCallback_trending);


    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>
<style>
.container {
    position: relative;
    text-align: center;
    color: white;
}
.title {
text-align: center;
}
.centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<body>

<h2 class="title">GIF loaded - preview image</h2>
<div class="container">
<img id="preview_sticker" src="" alt="" style="">
</div>

<h2 class="title">GIF loaded - share image</h2>
<div class="container">
<img id="share_sticker" src="" alt="" style="">
</div>

</body>
</html>`,
};

export const javascriptQuickStart = {
    launch:

`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for trending top 10 GIFs
function tenorCallback_trending(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_gifs = response_objects["results"];

    // load the GIFs -- for our example we will load the first GIFs preview size (nanogif) and share size (tinygif)

    document.getElementById("preview_gif").src = top_10_gifs[0]["media"][0]["nanogif"]["url"];

    document.getElementById("share_gif").src = top_10_gifs[0]["media"][0]["tinygif"]["url"];

    return;

}

// callback for GIF categories
function tenorCallback_categories(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    categories = response_objects["tags"];

    // load the categories - example is for the first category

    // url to load:
    var imgurl = categories[0]["image"];

    // text to overlay on image:
    var txt_overlay = categories[0]["name"];


    // search to run if user clicks the category
    var category_search_path = categories[0]["path"];

    document.getElementById("category_gif").src = imgurl
    document.getElementById("catgif_caption").innerHTML = txt_overlay
    document.getElementById("cat_link").href = category_search_path

    return;
}

// function to call the trending and category endpoints
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 10;

    // get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
    var trending_url = "https://g.tenor.com/v1/trending?key=" + apikey + "&limit=" + lmt;


    httpGetAsync(trending_url,tenorCallback_trending);

    // get the current list of categories - using the default locale of en_US
    var cat_url = "https://g.tenor.com/v1/categories?key=" + apikey;

    httpGetAsync(cat_url,tenorCallback_categories);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>
<style>
.container {
    position: relative;
    text-align: center;
    color: white;
}
.title {
text-align: center;
}
.centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<body>

<h2 class="title">GIF loaded - preview image</h2>
<div class="container">
<img id="preview_gif" src="" alt="" style="">
</div>

<h2 class="title">GIF loaded - share image</h2>
<div class="container">
<img id="share_gif" src="" alt="" style="">
</div>

<h2 class="title">GIF Category</h2>
<div class="container">
    <a id="cat_link" href="">
        <img id="category_gif" src="" alt="" style="">
        <div id="catgif_caption" class="centered"></div>
    </a>
</div>

</body>
</html>`,
    search:

`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for the top 8 GIFs of search
function tenorCallback_search(responsetext)
{
    // parse the json response
    var response_objects = JSON.parse(responsetext);

    top_10_gifs = response_objects["results"];

    // load the GIFs -- for our example we will load the first GIFs preview size (nanogif) and share size (tinygif)

    document.getElementById("preview_gif").src = top_10_gifs[0]["media"][0]["nanogif"]["url"];

    document.getElementById("share_gif").src = top_10_gifs[0]["media"][0]["tinygif"]["url"];

    return;

}


// function to call the trending and category endpoints
function grab_data()
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 8;

    // test search term
    var search_term = "excited";

    // using default locale of en_US
    var search_url = "https://g.tenor.com/v1/search?q=" + search_term + "&key=" +
            apikey + "&limit=" + lmt;

    httpGetAsync(search_url,tenorCallback_search);

    // data will be loaded by each call's callback
    return;
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// start the flow
grab_data();

</script>

<body>

<h2># 1 GIF loaded - preview image</h2>
<img id="preview_gif" src="" alt="" style="width:220px;height:164px;">

<h2># 1 GIF loaded - share image</h2>
<img id="share_gif" src="" alt="" style="width:498px;height:372px;">

</body>
</html>`,
    registershare:

`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for share event
function tenorCallback_share(responsetext)
{
    // no action is needed in the share callback
}


// function to call the register share endpoint
function send_share(search_term,shared_gifs_id)
{
    // set the apikey and limit
    var apikey = "LIVDSRZULELA";
    var lmt = 8;

    var share_url = "https://g.tenor.com/v1/registershare?id=" + shared_gifs_id + "&key=" + apikey
        + "&q=" + search_term;

    httpGetAsync(share_url,tenorCallback_share);
}

// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

// grab search term from cookies or some other storage
search_term = "excited";

// GIF id from the shared gif
// shared_gifs_id = gif_json_response_object_from_search[0][“id”]
shared_gifs_id = 5957952; // example

// send the share notifcation back to Tenor
send_share(search_term,shared_gifs_id);

alert("share sent!");


</script>

<body>

</body>
</html>`,
    autocomplete:

`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for share event
function tenorCallback_autocomplete(responsetext)
{
    var response_objects = JSON.parse(responsetext);

    predicted_words = response_objects["results"];

    document.getElementById("ac_1").innerHTML = predicted_words[0];
    document.getElementById("ac_2").innerHTML = predicted_words[1];
}

// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

//partial search term
psearch_term = "exc";

// set the apikey and limit
var apikey = "LIVDSRZULELA";
var lmt = 5;

// using default locale of en_US
var autoc_url = "https://g.tenor.com/v1/autocomplete?key=" + apikey + "&q=" + psearch_term
    + "&limit=" + lmt;

// send autocomplete request
httpGetAsync(autoc_url,tenorCallback_autocomplete);


</script>

<body>

<h2>Partial Search "exc":</h2>
<h3 id = "ac_1"></h3>
<h3 id = "ac_2"></h3>

</body>
</html>`,
    suggestions:

`<!DOCTYPE html>
<html>
<script>

${httpGetAsync}

// callback for share event
function tenorCallback_searchSuggestion(responsetext)
{
    var response_objects = JSON.parse(responsetext);

    predicted_words = response_objects["results"];

    document.getElementById("ac_1").innerHTML = predicted_words[0];
    document.getElementById("ac_2").innerHTML = predicted_words[1];
    document.getElementById("ac_3").innerHTML = predicted_words[2];
    document.getElementById("ac_4").innerHTML = predicted_words[3];
}


// SUPPORT FUNCTIONS ABOVE
// MAIN BELOW

//search term
psearch_term = "smile";

// set the apikey and limit
var apikey = "LIVDSRZULELA";
var lmt = 5;

// using default locale of en_US
var autoc_url = "https://g.tenor.com/v1/search_suggestions?key=" + apikey + "&q=" + psearch_term
    + "&limit=" + lmt;

// send search suggestion request
httpGetAsync(autoc_url,tenorCallback_searchSuggestion);


</script>

<body>

<h2>Search Suggestion for "smile":</h2>
<h3 id = "ac_1"></h3>
<h3 id = "ac_2"></h3>
<h3 id = "ac_3"></h3>
<h3 id = "ac_4"></h3>

</body>
</html>`,
};
